import { setStoreData } from "@claroty/utilities/store/StoreData";
import { subscribeSplunkProvider } from "@claroty/utilities/tracking/errorReporting";
import { StoreDataFromRedux } from "~/store/StoreDataFromRedux";
import { sendSplunkError } from "../tracking/splunk";
import { FULLSTORY_ORG_ID } from "../../configuration";
import { setFullStoryOrgId } from "@claroty/utilities/tracking/fullStoryUtils";

setStoreData(StoreDataFromRedux);
subscribeSplunkProvider({ sendSplunkError });
setFullStoryOrgId(FULLSTORY_ORG_ID);
